
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11699',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11699",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.451",
  "dashboard-client-types": "static-1.267",
  "data-fetching-client": "static-1.9525",
  "foundations-components": "static-1.7618",
  "foundations-components-legacy": "static-1.643",
  "foundations-theming": "static-1.4260",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7854",
  "hub-http-shared-msw-handlers": "static-1.9586",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11289",
  "I18n": "static-7.1584",
  "jasmine-runner": "static-1.6318",
  "marketplace-storefront-base": "static-1.11759",
  "quartz": "static-1.6797",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16498",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2711",
  "reporting-testing-lib": "static-1.8654",
  "settings-ui-lib": "static-1.12371",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6824",
  "ui-addon-i18n": "static-1.10992",
  "ui-addon-react-router-dom": "static-1.9393",
  "unified-auth": "static-1.279",
  "unified-auth-core-lib": "static-1.560",
  "usage-tracker": "static-1.7183",
  "usage-tracker-core": "static-1.7033",
  "customer-data-property-utils": "static-1.7928",
  "history": "static-4.47",
  "hub-http": "static-1.6065",
  "integrations-lib": "static-1.15576",
  "marketplace-ui-common": "static-1.19080",
  "property-management-iframe": "static-1.12535",
  "quartz-config": "static-1.575",
  "quartz-core": "static-1.6016",
  "quartz-routing": "static-1.227",
  "quick-fetch": "static-1.3782",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4486",
  "ts-schema": "static-1.3949",
  "ui-universal-auth": "static-1.8765",
  "UIComponents": "static-3.8236",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3274",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3074",
  "quartz-webpack": "static-1.3021",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3887",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4687",
  "foundations-theming-specialty": "static-1.1976",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9274",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5218",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1345",
  "ui-fonts": "static-1.551",
  "ui-images": "static-2.1109",
  "bend-plugin-foundations-theming": "static-1.2743",
  "foundations-theming-base": "static-1.3245",
  "stylex": "static-1.28",
  "HeadJS": "static-2.722",
  "hs-test-utils-bend-plugin": "static-1.2965",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4174",
  "ai-components-ui-library": "static-1.8485",
  "ai-rendering-library": "static-1.9452",
  "chirp-fetch": "static-1.1731",
  "connections-embed-lib": "static-1.706",
  "copilot-toolkit": "static-1.10654",
  "laboratory-lib": "static-3.7007",
  "marketplace-embed": "static-1.21596",
  "marketplace-ui-details": "static-1.8976",
  "marketplace-ui-reviews": "static-1.19036",
  "marketplace-ui-tracking": "static-1.13251",
  "sanitize-text": "static-1.7993",
  "ui-addon-video-player": "static-1.8544",
  "usage-tracker-multi": "static-1.5597",
  "usage-tracker-session-replay": "static-1.4869",
  "wootric-nps": "static-1.6830",
  "apollo-link-hub-http": "static-2.4499",
  "immer": "static-1.33",
  "immerable": "static-1.4002",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2392",
  "reporting-data": "static-1.66721",
  "cssUtils": "static-1.749",
  "flux-actions": "static-1.315",
  "HubStyle": "static-2.11597",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10059",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10221",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7173",
  "icons": "static-2.629",
  "marketplace-ui-apps-core": "static-1.17613",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4368",
  "foundations-components-test-utils": "static-1.5101",
  "quartz-i18n": "static-1.472",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3578",
  "customer-data-objects": "static-1.7499",
  "property-translator": "static-1.5258",
  "frontend-preferences-client": "static-1.7772",
  "hs-promise-utils": "static-1.5441",
  "hubspot-apollo-client": "static-1.4727",
  "integrations-error-boundary-lib": "static-1.12991",
  "integrations-tracking-lib": "static-1.5438",
  "native-integrations-shared-strings": "static-1.7635",
  "reselect": "static-2.16",
  "sanitize": "static-1.4322",
  "superstore": "static-1.4617",
  "ui-shepherd-react": "static-3.9994",
  "ai-settings-ui-library": "static-1.7601",
  "hub-http-janus": "static-1.807",
  "hubspotter-http": "static-1.4523",
  "immutable-less": "static-1.4502",
  "marketplace-ui-client-types": "static-1.16487",
  "nav-meta": "static-1.29065",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10090",
  "ui-addon-upgrades": "static-9.17725",
  "inbound-db-properties-service-client": "static-1.3715",
  "property-management-common": "static-1.4822",
  "ui-addon-iframeable": "static-1.8895",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.497",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.472",
  "quartz-head": "static-1.462",
  "quartz-test": "static-1.472",
  "quartz-tracking": "static-1.176",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20525",
  "ContentUtils": "static-1.67766",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2340",
  "customer-data-filters-ui": "static-1.39071",
  "customer-data-objects-ui-components": "static-1.12861",
  "customer-data-reference-ui-components": "static-1.12997",
  "embedded-academy-lib": "static-1.13721",
  "ExportDialog": "static-6.10235",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40777",
  "reporting-snowflake": "static-1.55339",
  "reporting-ui-components": "static-2.63992",
  "reporting-visualizations": "static-1.58797",
  "ui-addon-teams": "static-1.21305",
  "magpie-lib": "static-1.5442",
  "magpie-types": "static-1.4902",
  "simple-logging-lib": "static-1.2898",
  "navigation-components": "static-1.17428",
  "ai-studio-lib": "static-1.11123",
  "app-governance-lib": "static-1.1015",
  "developer-experience-shared-components": "static-1.10347",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7839",
  "ui-product-approvals": "static-1.27599",
  "ui-tool-access": "static-1.9992",
  "usage-based-billing-components-lib": "static-1.8140",
  "usage-tracker-anonymous": "static-1.5600",
  "usage-tracker-public": "static-1.6994",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3465",
  "persist-promise": "static-1.3556",
  "reference-resolvers": "static-1.8011",
  "ui-extensibility-client-types": "static-1.3789",
  "hubspot-apollo-cache": "static-1.186",
  "universal-page-editor-lib": "static-1.2850",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2310",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4918",
  "purchase-motions-components": "static-1.5545",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1399",
  "crm-component-utils": "static-1.38594",
  "crm-properties-common-lib": "static-1.5721",
  "customer-data-properties": "static-1.50916",
  "framework-data-schema-resolvers": "static-1.6721",
  "property-value-citations": "static-1.1530",
  "reference-resolvers-lite": "static-1.7931",
  "navigation-messaging": "static-1.6755",
  "hubspotter-http-shared-msw-handlers": "static-1.9584",
  "cms-field-types": "static-1.4657",
  "content-icons-ui": "static-1.2173",
  "conversations-skeleton-state": "static-1.7096",
  "crm-message-bus": "static-1.42503",
  "customer-data-filters-ui-msw-helpers": "static-1.21506",
  "customer-data-ui-utilities": "static-1.9672",
  "FormUrlGenerator": "static-2.4569",
  "framework-builder-read-service-client": "static-1.3877",
  "framework-data-schema-quick-fetch": "static-1.6626",
  "multi-account-reference-resolvers": "static-1.823",
  "onboarding-tours": "static-1.16333",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13193",
  "academy-common-lib": "static-1.13181",
  "content-assistance-lib": "static-1.7518",
  "dashboard-lib": "static-1.80823",
  "file-manager-components": "static-1.23041",
  "getting-started-shared-tasks": "static-1.18012",
  "hubspot-prosemirror": "static-1.17732",
  "hubspot-prosemirror-plugins": "static-1.17724",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19552",
  "share-with-third-party-component-lib": "static-1.8541",
  "ui-addon-draggable": "static-3.4615",
  "ui-asset-management-lib": "static-1.10773",
  "ui-business-units-lib": "static-1.8880",
  "user-context": "static-1.4948",
  "growth-payments-core": "static-1.24860",
  "reporting-plugins": "static-1.10038",
  "reporting-reports": "static-1.66399",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.573",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28960",
  "react-codemirror": "static-1.10474",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "apps-service-types": "static-1.3725",
  "oauth-service-types": "static-1.4095",
  "onboarding-scopes": "static-1.6311",
  "onboarding-tours-client": "static-1.4547",
  "platform-infra-nav-components": "static-1.7536",
  "subscription-experience-data-types": "static-1.14647",
  "crm-record-cards-service-types": "static-1.3486",
  "location-customization-utils-lib": "static-1.8714",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4347",
  "nav-client-types": "static-1.2205",
  "purchase-motions-api": "static-1.5548",
  "signup-constants": "static-1.18511",
  "signup-ui-url-generator": "static-2.7882",
  "trials-service-types": "static-1.3748",
  "card-properties-lib": "static-1.43657",
  "commerce-subscription-lib": "static-1.36593",
  "crm-actions": "static-1.6156",
  "crm-cards-sdk": "static-1.43060",
  "customer-data-properties-shared-msw-handlers": "static-1.8913",
  "customer-data-tracking": "static-1.6730",
  "hs-entities": "static-1.532",
  "pulse": "static-1.369",
  "calling-global-api": "static-1.63850",
  "calling-internal-common": "static-1.31147",
  "calling-lifecycle-internal": "static-1.65232",
  "calling-lifecycle-messages": "static-1.57526",
  "commerce-products-lib": "static-1.8981",
  "conditional-properties-service-client": "static-1.3667",
  "crm-links": "static-1.6117",
  "external-options-client-types": "static-1.4028",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4092",
  "meetings-icalendar-utils-lib": "static-1.480",
  "multi-currency-client-types": "static-1.3560",
  "object-builder-ui-client": "static-1.48156",
  "pipeline-validation-client-types": "static-1.3834",
  "smart-property-lib": "static-1.6119",
  "tiered-pricing": "static-1.901",
  "ui-addon-form-validation": "static-1.10841",
  "crm-pipelines-api-client-types": "static-1.4009",
  "customer-data-associations": "static-1.7171",
  "customer-data-views-management": "static-1.25087",
  "framework-data-table": "static-2.11527",
  "marketing-platform-lib": "static-1.6693",
  "nudge-client-utils": "static-1.2261",
  "nudge-custom-ui-functions": "static-1.767",
  "react-dnd-compat": "static-1.4468",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5206",
  "growth-onboarding-confetti": "static-1.2920",
  "growth-onboarding-next-action-utils": "static-1.1418",
  "onboarding-tours-utils": "static-1.399",
  "ui-shepherd-tracker": "static-1.7375",
  "academy-service-client": "static-1.3528",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28068",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8231",
  "video-components-external": "static-1.10706",
  "video-data-lib": "static-1.34364",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23064",
  "ui-addon-emoji-picker": "static-1.9735",
  "EmailSignatureEditor": "static-1.23983",
  "viral-links-lib": "static-1.6886",
  "data-token-picker": "static-1.16123",
  "FileManagerLib": "static-1.38681",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5092",
  "getting-started-shared-tasks-store": "static-1.17130",
  "campaign-roi-lib": "static-1.8424",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.240",
  "eligibility-engine-service-types": "static-1.3029",
  "crm_data": "static-4.91403",
  "customer-data-sidebar": "static-2.45541",
  "enrichment-properties-lib": "static-1.15237",
  "commerce-billing-lib": "static-1.18621",
  "commerce-shared-components-lib": "static-1.18076",
  "commerce-tools-ui-lib": "static-1.9913",
  "crm-fe-perf": "static-1.22753",
  "directed-graph": "static-1.787",
  "event-emitter": "static-1.795",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31153",
  "shared-worker-versioning": "static-1.10887",
  "calling-usage-tracker": "static-1.6389",
  "voice-sms-access-library": "static-1.384",
  "commerce-permissions": "static-1.611",
  "products-iframe-lib": "static-1.7455",
  "products-ui-components-shared-msw-handlers": "static-1.9968",
  "breeze-intelligence-kit": "static-1.5392",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9669",
  "policy-lib": "static-1.6625",
  "react-tinymce": "static-1.54752",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9732",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53878",
  "tinymce-plugins": "static-1.56992",
  "tinymce-themes": "static-1.55848",
  "crm-export-dialog": "static-1.6140",
  "crm-index-associations-lib": "static-1.6284",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1428",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2018",
  "nudge-renderer-utils": "static-1.2337",
  "whisper-core-api": "static-1.6124",
  "InboxConnectUtils": "static-4.14344",
  "growth-onboarding-next-action-components": "static-1.1446",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6429",
  "content-media-composition-data-lib": "static-1.11631",
  "content-media-compositions": "static-2.15638",
  "media-bridge-lib": "static-1.18645",
  "commerce-tours-lib": "static-1.5791",
  "growth-onboarding-reliability": "static-1.4934",
  "sales-checkout-service-client": "static-1.3515",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21388",
  "sales-email-signature-service-client": "static-1.3691",
  "audio-components": "static-1.5683",
  "FileManagerCore": "static-1.38540",
  "FileManagerImages": "static-1.36192",
  "video-components": "static-1.12709",
  "crm_universal": "static-1.21739",
  "customer-data-email": "static-1.17750",
  "card-payment-highlight-lib": "static-1.36646",
  "card-subscription-highlight-lib": "static-1.39016",
  "commerce-contract-lib": "static-1.11370",
  "customer-data-content": "static-1.26959",
  "invoices-highlight-card-lib": "static-1.54181",
  "orders-highlight-card-lib": "static-1.20986",
  "products-highlight-card-lib": "static-1.17265",
  "project-storage": "static-1.4581",
  "quotes-highlight-card-lib": "static-1.71355",
  "crm-source-interpretation-lib": "static-1.5180",
  "utility-belt": "static-1.2388",
  "payments-enrollment-embed-lib": "static-1.22149",
  "customer-data-rte": "static-1.32559",
  "cv-backend-services": "static-1.1515",
  "growth-onboarding-empty-states": "static-1.5438",
  "payments-post-enroll-local-storage-lib": "static-1.4962",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37445",
  "calling-orchestration-schema": "static-1.35161",
  "sales-views-client-types": "static-1.4134",
  "hub-http-contrib": "static-1.2891",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39963",
  "ui-addon-sales-email": "static-1.5062",
  "layout-dnd-components": "static-1.12130",
  "layout-dnd-utils": "static-1.11105",
  "ui-brand-identity-lib": "static-1.14223",
  "NamespacedHubStyle": "static-2.8940",
  "deal-intel-utils": "static-1.1432",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4379",
  "video-embed": "static-1.35198",
  "social-insights-client-types": "static-1.21506",
  "sequences-lib": "static-1.7762",
  "ui-gdpr-components": "static-1.10195",
  "products-ui-components": "static-1.39500",
  "quotes-ui-lib": "static-1.80076",
  "SalesContentIndexUI": "static-3.8974",
  "accounting-integrations-ui-components": "static-1.6802",
  "invoices-ui-lib": "static-1.54197",
  "commerce-products-api": "static-1.2027",
  "SafeStorage": "static-1.4250",
  "invoices-iframe-lib": "static-1.56255",
  "quotes-modal-lib": "static-1.102033",
  "stripe-embedded-components": "static-1.7218",
  "draft-content-plugins": "static-1.27826",
  "ContentData": "static-1.67841",
  "layout-data-lib": "static-1.9430",
  "outpost": "static-1.4048",
  "sequences-client-types-lib": "static-1.7619",
  "commerce-tax-lib": "static-1.365",
  "property-description-translator": "static-1.3704",
  "FireAlarmUi": "static-1.4377",
  "sales-templates-service-types-lib": "static-1.4036",
  "commerce-analytics-service-client": "static-1.3503",
  "totals-ui-components": "static-1.23114",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14887",
  "advanced-menus-lib": "static-1.11856",
  "ui-memberships-settings-lib": "static-1.33575",
  "commerce-totals-service-types": "static-1.3685",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14886",
  "simple-menus-lib": "static-1.16403"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11699",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.451",
  "dashboard-client-types": "/dashboard-client-types/static-1.267",
  "data-fetching-client": "/data-fetching-client/static-1.9525",
  "foundations-components": "/foundations-components/static-1.7618",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.643",
  "foundations-theming": "/foundations-theming/static-1.4260",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7854",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9586",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11289",
  "I18n": "/I18n/static-7.1584",
  "jasmine-runner": "/jasmine-runner/static-1.6318",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11759",
  "quartz": "/quartz/static-1.6797",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16498",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2711",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8654",
  "settings-ui-lib": "/settings-ui-lib/static-1.12371",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6824",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10992",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9393",
  "unified-auth": "/unified-auth/static-1.279",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.560",
  "usage-tracker": "/usage-tracker/static-1.7183",
  "usage-tracker-core": "/usage-tracker-core/static-1.7033",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7928",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6065",
  "integrations-lib": "/integrations-lib/static-1.15576",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19080",
  "property-management-iframe": "/property-management-iframe/static-1.12535",
  "quartz-config": "/quartz-config/static-1.575",
  "quartz-core": "/quartz-core/static-1.6016",
  "quartz-routing": "/quartz-routing/static-1.227",
  "quick-fetch": "/quick-fetch/static-1.3782",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4486",
  "ts-schema": "/ts-schema/static-1.3949",
  "ui-universal-auth": "/ui-universal-auth/static-1.8765",
  "UIComponents": "/UIComponents/static-3.8236",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3274",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3074",
  "quartz-webpack": "/quartz-webpack/static-1.3021",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3887",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4687",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1976",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9274",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5218",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1345",
  "ui-fonts": "/ui-fonts/static-1.551",
  "ui-images": "/ui-images/static-2.1109",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2743",
  "foundations-theming-base": "/foundations-theming-base/static-1.3245",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.722",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2965",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4174",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8485",
  "ai-rendering-library": "/ai-rendering-library/static-1.9452",
  "chirp-fetch": "/chirp-fetch/static-1.1731",
  "connections-embed-lib": "/connections-embed-lib/static-1.706",
  "copilot-toolkit": "/copilot-toolkit/static-1.10654",
  "laboratory-lib": "/laboratory-lib/static-3.7007",
  "marketplace-embed": "/marketplace-embed/static-1.21596",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8976",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19036",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13251",
  "sanitize-text": "/sanitize-text/static-1.7993",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8544",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5597",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4869",
  "wootric-nps": "/wootric-nps/static-1.6830",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4499",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4002",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2392",
  "reporting-data": "/reporting-data/static-1.66721",
  "cssUtils": "/cssUtils/static-1.749",
  "flux-actions": "/flux-actions/static-1.315",
  "HubStyle": "/HubStyle/static-2.11597",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10059",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10221",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7173",
  "icons": "/icons/static-2.629",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17613",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4368",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5101",
  "quartz-i18n": "/quartz-i18n/static-1.472",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3578",
  "customer-data-objects": "/customer-data-objects/static-1.7499",
  "property-translator": "/property-translator/static-1.5258",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7772",
  "hs-promise-utils": "/hs-promise-utils/static-1.5441",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4727",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12991",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5438",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7635",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4322",
  "superstore": "/superstore/static-1.4617",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9994",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7601",
  "hub-http-janus": "/hub-http-janus/static-1.807",
  "hubspotter-http": "/hubspotter-http/static-1.4523",
  "immutable-less": "/immutable-less/static-1.4502",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16487",
  "nav-meta": "/nav-meta/static-1.29065",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10090",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17725",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3715",
  "property-management-common": "/property-management-common/static-1.4822",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8895",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.497",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.472",
  "quartz-head": "/quartz-head/static-1.462",
  "quartz-test": "/quartz-test/static-1.472",
  "quartz-tracking": "/quartz-tracking/static-1.176",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20525",
  "ContentUtils": "/ContentUtils/static-1.67766",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2340",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39071",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12861",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12997",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13721",
  "ExportDialog": "/ExportDialog/static-6.10235",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40777",
  "reporting-snowflake": "/reporting-snowflake/static-1.55339",
  "reporting-ui-components": "/reporting-ui-components/static-2.63992",
  "reporting-visualizations": "/reporting-visualizations/static-1.58797",
  "ui-addon-teams": "/ui-addon-teams/static-1.21305",
  "magpie-lib": "/magpie-lib/static-1.5442",
  "magpie-types": "/magpie-types/static-1.4902",
  "simple-logging-lib": "/simple-logging-lib/static-1.2898",
  "navigation-components": "/navigation-components/static-1.17428",
  "ai-studio-lib": "/ai-studio-lib/static-1.11123",
  "app-governance-lib": "/app-governance-lib/static-1.1015",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10347",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7839",
  "ui-product-approvals": "/ui-product-approvals/static-1.27599",
  "ui-tool-access": "/ui-tool-access/static-1.9992",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8140",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5600",
  "usage-tracker-public": "/usage-tracker-public/static-1.6994",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3465",
  "persist-promise": "/persist-promise/static-1.3556",
  "reference-resolvers": "/reference-resolvers/static-1.8011",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3789",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.186",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2850",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2310",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4918",
  "purchase-motions-components": "/purchase-motions-components/static-1.5545",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1399",
  "crm-component-utils": "/crm-component-utils/static-1.38594",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5721",
  "customer-data-properties": "/customer-data-properties/static-1.50916",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6721",
  "property-value-citations": "/property-value-citations/static-1.1530",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7931",
  "navigation-messaging": "/navigation-messaging/static-1.6755",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9584",
  "cms-field-types": "/cms-field-types/static-1.4657",
  "content-icons-ui": "/content-icons-ui/static-1.2173",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7096",
  "crm-message-bus": "/crm-message-bus/static-1.42503",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21506",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9672",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4569",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3877",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6626",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.823",
  "onboarding-tours": "/onboarding-tours/static-1.16333",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13193",
  "academy-common-lib": "/academy-common-lib/static-1.13181",
  "content-assistance-lib": "/content-assistance-lib/static-1.7518",
  "dashboard-lib": "/dashboard-lib/static-1.80823",
  "file-manager-components": "/file-manager-components/static-1.23041",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18012",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17732",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17724",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19552",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8541",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4615",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10773",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8880",
  "user-context": "/user-context/static-1.4948",
  "growth-payments-core": "/growth-payments-core/static-1.24860",
  "reporting-plugins": "/reporting-plugins/static-1.10038",
  "reporting-reports": "/reporting-reports/static-1.66399",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.573",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28960",
  "react-codemirror": "/react-codemirror/static-1.10474",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "apps-service-types": "/apps-service-types/static-1.3725",
  "oauth-service-types": "/oauth-service-types/static-1.4095",
  "onboarding-scopes": "/onboarding-scopes/static-1.6311",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4547",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7536",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14647",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3486",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8714",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4347",
  "nav-client-types": "/nav-client-types/static-1.2205",
  "purchase-motions-api": "/purchase-motions-api/static-1.5548",
  "signup-constants": "/signup-constants/static-1.18511",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7882",
  "trials-service-types": "/trials-service-types/static-1.3748",
  "card-properties-lib": "/card-properties-lib/static-1.43657",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36593",
  "crm-actions": "/crm-actions/static-1.6156",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43060",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8913",
  "customer-data-tracking": "/customer-data-tracking/static-1.6730",
  "hs-entities": "/hs-entities/static-1.532",
  "pulse": "/pulse/static-1.369",
  "calling-global-api": "/calling-global-api/static-1.63850",
  "calling-internal-common": "/calling-internal-common/static-1.31147",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65232",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57526",
  "commerce-products-lib": "/commerce-products-lib/static-1.8981",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3667",
  "crm-links": "/crm-links/static-1.6117",
  "external-options-client-types": "/external-options-client-types/static-1.4028",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4092",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.480",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3560",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48156",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3834",
  "smart-property-lib": "/smart-property-lib/static-1.6119",
  "tiered-pricing": "/tiered-pricing/static-1.901",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10841",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4009",
  "customer-data-associations": "/customer-data-associations/static-1.7171",
  "customer-data-views-management": "/customer-data-views-management/static-1.25087",
  "framework-data-table": "/framework-data-table/static-2.11527",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6693",
  "nudge-client-utils": "/nudge-client-utils/static-1.2261",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.767",
  "react-dnd-compat": "/react-dnd-compat/static-1.4468",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5206",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2920",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1418",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.399",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7375",
  "academy-service-client": "/academy-service-client/static-1.3528",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28068",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8231",
  "video-components-external": "/video-components-external/static-1.10706",
  "video-data-lib": "/video-data-lib/static-1.34364",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23064",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9735",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23983",
  "viral-links-lib": "/viral-links-lib/static-1.6886",
  "data-token-picker": "/data-token-picker/static-1.16123",
  "FileManagerLib": "/FileManagerLib/static-1.38681",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5092",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17130",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8424",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.240",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3029",
  "crm_data": "/crm_data/static-4.91403",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45541",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15237",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18621",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18076",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9913",
  "crm-fe-perf": "/crm-fe-perf/static-1.22753",
  "directed-graph": "/directed-graph/static-1.787",
  "event-emitter": "/event-emitter/static-1.795",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31153",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10887",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6389",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.384",
  "commerce-permissions": "/commerce-permissions/static-1.611",
  "products-iframe-lib": "/products-iframe-lib/static-1.7455",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9968",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5392",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9669",
  "policy-lib": "/policy-lib/static-1.6625",
  "react-tinymce": "/react-tinymce/static-1.54752",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9732",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53878",
  "tinymce-plugins": "/tinymce-plugins/static-1.56992",
  "tinymce-themes": "/tinymce-themes/static-1.55848",
  "crm-export-dialog": "/crm-export-dialog/static-1.6140",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6284",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1428",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2018",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2337",
  "whisper-core-api": "/whisper-core-api/static-1.6124",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14344",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1446",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6429",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11631",
  "content-media-compositions": "/content-media-compositions/static-2.15638",
  "media-bridge-lib": "/media-bridge-lib/static-1.18645",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5791",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4934",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3515",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21388",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3691",
  "audio-components": "/audio-components/static-1.5683",
  "FileManagerCore": "/FileManagerCore/static-1.38540",
  "FileManagerImages": "/FileManagerImages/static-1.36192",
  "video-components": "/video-components/static-1.12709",
  "crm_universal": "/crm_universal/static-1.21739",
  "customer-data-email": "/customer-data-email/static-1.17750",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36646",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39016",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11370",
  "customer-data-content": "/customer-data-content/static-1.26959",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54181",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20986",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17265",
  "project-storage": "/project-storage/static-1.4581",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71355",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5180",
  "utility-belt": "/utility-belt/static-1.2388",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22149",
  "customer-data-rte": "/customer-data-rte/static-1.32559",
  "cv-backend-services": "/cv-backend-services/static-1.1515",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5438",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4962",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37445",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35161",
  "sales-views-client-types": "/sales-views-client-types/static-1.4134",
  "hub-http-contrib": "/hub-http-contrib/static-1.2891",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39963",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5062",
  "layout-dnd-components": "/layout-dnd-components/static-1.12130",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11105",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14223",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8940",
  "deal-intel-utils": "/deal-intel-utils/static-1.1432",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4379",
  "video-embed": "/video-embed/static-1.35198",
  "social-insights-client-types": "/social-insights-client-types/static-1.21506",
  "sequences-lib": "/sequences-lib/static-1.7762",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10195",
  "products-ui-components": "/products-ui-components/static-1.39500",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80076",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8974",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6802",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54197",
  "commerce-products-api": "/commerce-products-api/static-1.2027",
  "SafeStorage": "/SafeStorage/static-1.4250",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56255",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102033",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7218",
  "draft-content-plugins": "/draft-content-plugins/static-1.27826",
  "ContentData": "/ContentData/static-1.67841",
  "layout-data-lib": "/layout-data-lib/static-1.9430",
  "outpost": "/outpost/static-1.4048",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7619",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.365",
  "property-description-translator": "/property-description-translator/static-1.3704",
  "FireAlarmUi": "/FireAlarmUi/static-1.4377",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4036",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3503",
  "totals-ui-components": "/totals-ui-components/static-1.23114",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14887",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33575",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3685",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14886",
  "simple-menus-lib": "/simple-menus-lib/static-1.16403"
}
};
